import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  TargetActionTypes,
  GET_TARGET_LIST_API,
  POST_TARGET_API,
  GET_TARGET_DETAILS_API,
  DELETE_TARGET_API,
  GET_DEFAULT_TARGET_SETTINGS, 
} from '../constants/ApiConstants';
import { createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../../actions/utilAction';
import { getSkillAcquisitionTargetList } from '../../../../../patients/components/DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';

export const getTargetList = (searchObj, programID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(TargetActionTypes.get_targetList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_TARGET_LIST_API}${query_params}&programId=${programID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(TargetActionTypes.get_targetList.SUCCESS, response));
        } else {
          dispatch(actionCreator(TargetActionTypes.get_targetList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_targetList ', error);
      });
  };
};

export const saveTarget = (formData, patientId, skillsAcquisitionProgramId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(TargetActionTypes.post_target.REQUEST));
    fetch(POST_TARGET_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(TargetActionTypes.post_target.SUCCESS, response));
          if(patientId > 0 && skillsAcquisitionProgramId > 0)
          {
            let searchObj = {
              sort_fields: '',
              sort_order: '',
              contain_filters: { SearchText:  null },
              pageNumber: 1,
            };
            dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId))
          }
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(TargetActionTypes.post_target.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_target', error);
      });
  };
};

export const getTargetDetails = (targetID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(TargetActionTypes.get_targetDetails.REQUEST));
    fetch(`${GET_TARGET_DETAILS_API}?targetId=${targetID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(TargetActionTypes.get_targetDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(TargetActionTypes.get_targetDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_targetDetails ', error);
      });
  };
};

export const deleteTarget = (targetID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(TargetActionTypes.delete_target.REQUEST));
    fetch(`${DELETE_TARGET_API}?targetId=${targetID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) { 
          showSuccessMessage(response.message);
          dispatch(actionCreator(TargetActionTypes.delete_target.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(TargetActionTypes.delete_target.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(TargetActionTypes.delete_target.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_target', error);
      });
  };
};

export const getDefaultTargetSettingsData = () => {
    return (dispatch, getState) => {
        dispatch(actionCreator(TargetActionTypes.get_defaultTargetSettings.REQUEST));
        fetch(`${GET_DEFAULT_TARGET_SETTINGS}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(TargetActionTypes.get_defaultTargetSettings.SUCCESS, response));
                } else {
                    dispatch(actionCreator(TargetActionTypes.get_defaultTargetSettings.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionTargetDetail', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/target/actions/targetActions.js